module.exports = __webpack_public_path__ + "site/img/serviceenNew.67b8a246.png";